import React, { useState } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useTheme } from '../context/ThemeContext';
import { paperStyles, paperStylesDark, boxStyles } from '../utils/muiStyles';


import FileUpload from "../components/File/FileUpload";
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import TextField from '@mui/material/TextField';


const Reprice = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // return (
  //   <Box sx={boxStyles}>
  //     <Paper sx={isDark ? paperStylesDark : paperStyles}>
        
  //     </Paper>

  //     <Paper sx={isDark ? paperStylesDark : paperStyles}>
  //       <Typography variant="h6" gutterBottom>
  //         Rebase Options
  //       </Typography>
  //       {/* Add rebase controls and status here */}
  //     </Paper>
  //   </Box>
  // );

  const [newUserInfo, setNewUserInfo] = useState({x12Docs: []});
	const [postResult, setPostResult] = useState(null);
	const [changeResult, setChangeResult] = useState(null);

	const [selected, setSelected] = React.useState([]);

	const handleSelect = (event, nodeIds) => {
		setSelected(nodeIds);
	};

	const handleDownload = () => {
			};
	const formatResponse = (data) => {

		const enList = data.filter(d => d.envelope).map((en) => {
			const fgList = en.envelope.functionalGroups.map((fg) => {
				const tsList = fg.transactionSets.map((ts) => {
					const sgList = ts.segments.map((sg) => {
						return (
							<div>
								<TreeItem nodeId={sg.line} label={sg.line}></TreeItem>
							</div>
						);
					});
					return (<TreeItem nodeId={ts.header} label={ts.header}>
						{sgList}
					</TreeItem>);
				});
				return (<TreeItem nodeId={fg.header} label={fg.header}>
					{tsList}
				</TreeItem>);
			});
			return (
				<TreeItem nodeId={en.originalFilename} label={en.originalFilename}>
					<TreeItem nodeId={en.envelope.header} label={en.envelope.header}>
						{fgList}
					</TreeItem>
				</TreeItem>
			);
		});

		return (
			<Box >
				<Box>
					<Button onClick={handleDownload}>Download</Button>
				</Box>
				<TreeView
					aria-label="file system navigator"
					defaultCollapseIcon={<ExpandMoreIcon />}
					defaultExpandIcon={<ChevronRightIcon />}
					onNodeSelect={handleSelect}
				>
					<TreeItem nodeId="1" label="Results">
						{enList}
					</TreeItem>
				</TreeView>
			</Box>
		);
	}

	const updateUploadedFiles = (files) =>
		setNewUserInfo({ ...newUserInfo, x12Docs: files });

	const handleSubmit = async (event) => {
		event.preventDefault();
		// Simple POST request with a JSON body using fetch

		var formData = new FormData();
		// formData.append("name", name);
		for (var i = 0; i < newUserInfo.x12Docs.length; i++) {
			formData.append("files", newUserInfo.x12Docs[i]);
		}

		if (changeResult) {
			formData.append("filters", myObjString);
		}

		const requestOptions = {
			method: 'POST',
			body: formData
		};

		try {
			let res;

			if (value == 'filter') {
				res = await fetch('https://veritasallies.net/opensearch/testFilter', requestOptions);
			} else if (value == 'reprice') {
				res = await fetch('https://veritasallies.net/opensearch/upload', requestOptions);
			} else if (value == 'report'){
				res = await fetch('https://veritasallies.net/opensearch/report', requestOptions);
			} else if (value == 'scandx'){
				res = await fetch('https://veritasallies.net/opensearch/scandx', requestOptions);
			}

			if (!res.ok) {
				const message = `An error has occured: ${res.status} - ${res.statusText}`;
				throw new Error(message);
			}

			const data = await res.json();

			const result = {
				status: res.status + "-" + res.statusText,
				headers: {
					"Content-Type": res.headers.get("Content-Type"),
					"Content-Length": res.headers.get("Content-Length"),
				},
				data: data
			};



			setPostResult(formatResponse(result.data));
		} catch (err) {
			setPostResult(err.message);
		}
	};

	const [value, setValue] = useState('reprice');

	const handleRadio = (event) => {
				setValue(event.target.value);
		if (event.target.value == 'filter') {
			setChangeResult(true);
		} else {
			setChangeResult(false);
		}

	};

	const [myMap, setMyMap] = useState(new Map());
	const [myObjString, setMyObjString] = useState("{}");

	const handleGroupIdChange = (event) => {
		if (event.target.value == "") {
			myMap.delete(event.target.name);
		} else {
			myMap.set(event.target.name, event.target.value);
		}
		//setMyMap();
		setMyObjString(JSON.stringify(mapToObj(myMap)));
	};

	/*
 * Turn the map<String, Object> to an Object so it can be converted to JSON
				*/
	function mapToObj(inputMap) {
		let obj = {};

		inputMap.forEach(function(value, key) {
			obj[key] = value;
		});

		return obj;
	}

	return (
		<div className="main-content page-reprice">
			<div>
       
				<form onSubmit={handleSubmit}>
					<FileUpload
						accept="*.*"
						// label="X12 Claims"
						multiple
						updateFilesCb={updateUploadedFiles}
						trackRadio={handleRadio}
					/>
					<div style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}>
						{changeResult &&
							<div className="alert alert-secondary mt-2" role="alert">
								<pre>
									<Box
										sx={{
											display: 'flex',
											alignItems: 'center',
											'& > :not(style)': { m: 1 },
										}}
									>
										<TextField id="outlined-basic1" label="GroupId" name="1" variant="outlined" size="small" onChange={handleGroupIdChange} />
										<TextField id="outlined-basic2" label="GroupId" name="2" variant="outlined" size="small" onChange={handleGroupIdChange} />
										<TextField id="outlined-basic3" label="GroupId" name="3" variant="outlined" size="small" onChange={handleGroupIdChange} />
										<TextField id="outlined-basic4" label="GroupId" name="4" variant="outlined" size="small" onChange={handleGroupIdChange} />
									</Box>
								</pre>
							</div>
						}
					</div>
					<button className="action" type="submit">Submit</button>
				</form>
			</div>

			<div>{postResult && <div className="alert alert-secondary mt-2" role="alert"><pre>{postResult}</pre></div>}</div>
		</div>
	);


};

export default Reprice; 